import { useQuery } from "@tanstack/react-query";

import api from "../api";
import { paranoidModeQueryKey } from "../queryKeys";
import { allComponentsByLevel } from "../@types";

const useParanoidMode = () => {
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: paranoidModeQueryKey,
    queryFn: () => api.getParanoidModeConfig(),
    select: ({ data: paranoidModeConfig }) => {
      const enabledComponents = {
        ...allComponentsByLevel,
        [paranoidModeConfig.level]: paranoidModeConfig.included
      };
      return { paranoidModeConfig, enabledComponents };
    }
  });

  return {
    ...data,
    isLoading,
    isSuccess
  };
};

export default useParanoidMode;
